import { ChatsSearch } from './history/chats-search';
import styles from './chat-side-panel-chats.module.css';

/**
 * The chat side panel's Chats view (PLT-7883): every conversation and the search over them, the
 * same `ChatsSearch` the Chats page shows. It takes the panel's body in place of the conversation
 * rather than dropping down from the header, because search results each carry a matched line and
 * need the panel's full height. Picking a conversation opens it in the panel, so the reader stays
 * on the page they were reading.
 *
 * The search is the panel's, not the URL's: the panel sits over whatever page the reader is on,
 * and that page owns the URL.
 */
export function ChatSidePanelChats({
  query,
  onSearch,
  currentConversationId,
  onOpenConversation,
}: {
  query: string;
  onSearch: (query: string) => void;
  currentConversationId: string | null;
  onOpenConversation: (id: string) => void;
}) {
  return (
    <div className={styles.view}>
      <ChatsSearch
        query={query}
        onSearch={onSearch}
        focusKey="open"
        onOpenConversation={onOpenConversation}
        currentConversationId={currentConversationId}
        bodyClassName={styles.body}
      />
    </div>
  );
}
